<template>
  <section class="content">
    <div class="form-steps-outer">
      <div id="back-to-quote-request">
        <div class="btn btn-primary sq" @click="$emit('close-rates')">
          Back <i class="fa fa-arrow-left"></i>
        </div>
      </div>
      <div class="backer clearfix inverse">
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
          <div class="tag">
            <div class="key-head">Origin</div>
            <div class="val">{{ this.request.origin || 'None set' }}</div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
          <div class="tag">
            <div class="key-head">Destination</div>
            <div class="val">{{ this.request.dest || 'None set' }}</div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
          <div class="tag">
            <div class="key-head">Client Name</div>
            <div class="val">
              {{ this.request.firstName + this.request.lastName !== '' ? this.request.firstName + ' ' + this.request.lastName : 'None set' }}
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
          <div class="tag">
            <div class="key-head">Booking Agent</div>
            <div class="val">{{ this.request.booker || 'None set' }}</div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
          <div class="tag">
            <div class="key-head">Account</div>
            <div class="val">{{ this.request.account || 'None set' }}</div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
          <div class="tag">
            <div class="key-head">Job Type</div>
            <div class="val">{{ this.request.jobType || 'None set' }}</div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
          <div class="tag">
            <div class="key-head">Weight (Net LBS)</div>
            <div class="val">{{ this.request.weightsAndVolume.weightLbs && this.request.weightsAndVolume.weightLbs.net ? numberFormat(this.request.weightsAndVolume.weightLbs.net) : 'None set' }}</div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
          <div class="tag">
            <div class="key-head">Volume (Net CbFt)</div>
            <div class="val">{{ this.request.weightsAndVolume.cubicFt && this.request.weightsAndVolume.cubicFt.net ? numberFormat(this.request.weightsAndVolume.cubicFt.net) : 'None set' }}</div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
          <div class="tag">
            <div class="key-head">Weight (Net KG)</div>
            <div class="val">{{ this.request.weightsAndVolume.weightKgs && this.request.weightsAndVolume.weightKgs.net ? numberFormat(this.request.weightsAndVolume.weightKgs.net) : 'None set' }}</div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
          <div class="tag">
            <div class="key-head">Volume (Net CBM)</div>
            <div class="val">{{ this.request.weightsAndVolume.cubicM && this.request.weightsAndVolume.cubicM.net ? numberFormat(this.request.weightsAndVolume.cubicM.net) : 'None set' }}</div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
          <div class="tag">
            <div class="key-head">Cheapest Route Cost</div>
            <div class="val">{{ cheapest }}</div>
          </div>
        </div>
      </div>
    </div>
    <ul class="nav nav-pills nav-justified mai-nav-pills">
      <li @click="pill = 'rates'" :class="[ pill === 'rates' ? 'active' : '' ]"><a>Rates Overview</a></li>
      <li @click="pill = 'analysis'" :class="[ pill === 'analysis' ? 'active' : '' ]"><a>Rates Analysis</a></li>
    </ul>
    <section id="rates" class="clearfix">
      <div v-show="!graphVisible && pill === 'rates'">
        <div class="select-sort clearfix">
          <div class="msg">
            {{ orderedRates.length }} quotes
          </div>
          <select v-model="sortBy">
            <option value="cheap">Cheapest first</option>
            <option value="exp">Most expensive first</option>
            <option value="quick">Quickest first</option>
            <option value="slow">Slowest first</option>
            <option value="high">Highest quality</option>
            <option value="low">Lowest quality</option>
          </select>
        </div>
        <rate
          v-on:chosen="chosen"
          v-on:item-chosen="itemChosen"
          v-for="(rate, i) in orderedRates"
          :key="rate.optionNumber" :index="i"
          :rate="rate"
          :currency="response.responseCurrency"
          :reporting-currency="response.reportingCurrency"
          v-on:show-network-graph="showGraph"
          :getQuality="getQuality"
          >
        </rate>
        <quote-rate-break-down
          v-if="choiceMade && choice !== null"
          v-on:close="choiceMade = false; choice = null"
          :rate="getRate(choice)"
          :reportingCurrency="response.reportingCurrency"
          v-on:dataChange="data => $emit('quoteDetailsUpdate', data)"
          :fName="request.firstName"
          :lName="request.lastName"
          :pu-date="request.pickUpDate"
          :brand-grp="request.brandGroup"
          :request="fullRequest"
          :response="response"
          :job="job"
          :pref-with-notes="prefWithNotes"
          v-on:job-saved="jobSaved"
          v-on:job-save-error="showError"
          style="top: -430px; position: absolute; height: 800px;"
        />
        <quote-rate-item-break-down
          v-if="itemChoiceMade && itemChoice !== null && itemChoiceIndex !== null"
          v-on:close="itemChoiceMade = false; itemChoice = null; itemChoiceIndex = null"
          :rate="getRate(itemChoice)"
          :itemIndex="itemChoiceIndex"
          :request="fullRequest"
          :response="response"
          v-on:update-option="updateOption"
          style="top: -430px; position: absolute; height: 800px;"
        />
      </div>
      <div v-if="graphVisible && pill === 'rates'">
        <network-graph
          :graphData="graphData"
          :visible="graphVisible"
          :highlight="pathNumber"
          v-on:close-graph="graphVisible = false"
        />
      </div>
      <div v-show="pill === 'analysis'">
        <div class="col-xs-12">
          <div class="clearfix">
            <div class="panel panel-default mai-panel">
              <div class="panel-heading"><i class="fa fa-bar-chart"></i> Route segment comparison (Option Number by Cost)</small></div>
              <div class="panel-body clearfix" style="min-height: 380px;">
                <simple-stacked-bar :showLegend="false" :chartData="stackedData" categoryField="Option Number"></simple-stacked-bar>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="clearfix">
            <div class="panel panel-default mai-panel">
              <div class="panel-heading"><i class="fa fa-bar-chart"></i> Route duration comparison (Option Number by Days)</small></div>
              <div class="panel-body clearfix" style="min-height: 380px;">
                <simple-bar :showLegend="false" :chartData="durationChartData" valueField="Duration" categoryField="Option Number"></simple-bar>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="clearfix">
            <div class="panel panel-default mai-panel">
              <div class="panel-heading"><i class="fa fa-bar-chart"></i> Route overall comparison (Option Number by Rate in hundreds by Quality score out of 100 by Duration in days)</small></div>
              <div class="panel-body clearfix" style="min-height: 380px;">
                <simple-layered-bar :cluster="false" :minHeight="700" :showLegend="false" :chartData="layeredData" categoryField="Option Number"></simple-layered-bar>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="clearfix">
            <div class="panel panel-default mai-panel">
              <div class="panel-heading"><i class="fa fa-bar-chart"></i> Route quality comparison (Option Number by score/100)</small></div>
              <div class="panel-body clearfix" style="min-height: 380px;">
                <simple-bar :showLegend="false" :chartData="qualityChartData" valueField="Quality" categoryField="Option Number"></simple-bar>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>
<script>
  import Rate from './QuoteRate.vue'
  import QuoteRateBreakDown from './QuoteRateBreakDown'
  import VueScrollTo from 'vue-scrollto'
  import QuoteRateItemBreakDown from './QuoteRateItemBreakDown'
  import NetworkGraph from './NetworkGraph'
  import SimpleStackedBar from '../../../components/charts/SimpleStackedBar'
  import SimpleLayeredBar from '../../../components/charts/SimpleLayeredBar'
  import SimpleBar from '../../../components/charts/SimpleBar'
  import event from '../../../event'
  export default {
    name: 'QuoteRates',
    props: [ 'response', 'request', 'graphData', 'fullRequest', 'chargeProfile', 'job', 'prefWithNotes' ],
    components: {
      NetworkGraph,
      QuoteRateItemBreakDown,
      QuoteRateBreakDown,
      SimpleStackedBar,
      SimpleBar,
      Rate,
      SimpleLayeredBar
    },
    data () {
      return {
        pathNumber: null,
        sort: false,
        order: false,
        graphVisible: false,
        choiceMade: false,
        choice: null,
        itemChoiceMade: false,
        itemChoice: null,
        itemChoiceIndex: null,
        sortBy: 'cheap',
        pill: 'rates'
      }
    },
    computed: {
      providersCodeToName () {
        return this.$store.getters['quote/providersCodeToName']
      },
      layeredData () {
        return this.response.option.map(obj => {
          return {
            'Option Number': obj.optionNumber,
            ['Option Number ' + obj.optionNumber + ' - Quality']: this.getQuality(obj.item),
            ['Option Number ' + obj.optionNumber + ' - Rate (in hundreds)']: this.numberFormat(obj.optionTotal / 100),
            ['Option Number ' + obj.optionNumber + ' - Duration']: this.numberFormat(this.getDuration(obj))
          }
        })
      },
      qualityChartData () {
        return this.response.option.map(obj => {
          return {
            'Option Number': obj.optionNumber,
            Quality: this.getQuality(obj.item)
          }
        })
      },
      durationChartData () {
        return this.response.option.map(obj => {
          return {
            'Option Number': obj.optionNumber,
            Duration: this.getDuration(obj)
          }
        })
      },
      stackedData () {
        return this.response.option.map(obj => {
          let o = {
            'Option Number': obj.optionNumber
          }
          obj.item.forEach(item => {
            o[this.makeTag(obj.optionNumber, item.service, item.serviceProviderName)] = item.baseRate
          })
          return o
        })
      },
      responseNOTUSED () {
        return this.$store.getters['quote/rate']
      },
      optionsByDurationDesc () {
        const arr = this.response.option.slice(0)
        const ret = arr.sort((a, b) => {
          let sortVal = this.getDuration(b) - this.getDuration(a)
          let optionVal = b.optionNumber - a.optionNumber
          return sortVal === 0 ? optionVal : sortVal
        })
        return ret
      },
      optionsByDurationAsc () {
        const arr = this.response.option.slice(0)
        const ret = arr.sort((a, b) => {
          let sortVal = this.getDuration(a) - this.getDuration(b)
          let optionVal = a.optionNumber - b.optionNumber
          return sortVal === 0 ? optionVal : sortVal
        })
        return ret
      },
      optionsByCostDesc () {
        const arr = this.response.option.slice(0)
        const ret = arr.sort((a, b) => {
          let sortVal = b.optionTotal - a.optionTotal
          let optionVal = b.optionNumber - a.optionNumber
          return sortVal === 0 ? optionVal : sortVal
        })
        return ret
      },
      optionsByCostAsc () {
        const arr = this.response.option.slice(0)
        const ret = arr.sort((a, b) => {
          let sortVal = a.optionTotal - b.optionTotal
          let optionVal = a.optionNumber - b.optionNumber
          return sortVal === 0 ? optionVal : sortVal
        })
        return ret
      },
      optionsByQualityDesc () {
        const arr = this.response.option.slice(0)
        const ret = arr.sort((a, b) => {
          let sortVal = this.getQuality(b.item) - this.getQuality(a.item)
          let optionVal = a.optionNumber - b.optionNumber
          return sortVal === 0 ? optionVal : sortVal
        })
        return ret
      },
      optionsByQualityAsc () {
        const arr = this.response.option.slice(0)
        const ret = arr.sort((a, b) => {
          let sortVal = this.getQuality(a.item) - this.getQuality(b.item)
          let optionVal = b.optionNumber - a.optionNumber
          return sortVal === 0 ? optionVal : sortVal
        })
        return ret
      },
      orderedRates () {
        /*
        if (!this.sort && !this.order) {
          return this.optionsByCostDesc
        } else if (!this.sort && this.order) {
          return this.optionsByCostAsc
        } else if (this.sort && !this.order) {
          return this.optionsByDurationDesc
        } else if (this.sort && this.order) {
          return this.optionsByDurationAsc
        }
        */
        let ret
        switch (this.sortBy) {
          case 'cheap':
            ret = this.optionsByCostAsc
            break
          case 'exp':
            ret = this.optionsByCostDesc
            break
          case 'quick':
            ret = this.optionsByDurationAsc
            break
          case 'slow':
            ret = this.optionsByDurationDesc
            break
          case 'high':
            ret = this.optionsByQualityDesc
            break
          case 'low':
            ret = this.optionsByQualityAsc
            break
          default:
            ret = this.optionsByCostAsc
            break
        }
        return ret
      },
      cheapest () {
        return this.optionsByCostAsc.length ? (this.numberFormat(this.optionsByCostAsc[0].optionTotal) + ' ' + this.fullRequest.ResponseCurrency) : ''
      }
    },
    methods: {
      jobSaved (job) {
        this.choiceMade = false
        this.choice = null
        this.$emit('job-saved', job)
        event.$emit('toast', { type: 'success', message: 'Job Saved' })
      },
      showError () {
        event.$emit('toast', { type: 'error', message: 'An error occurred while saving; please try again or contact support' })
      },
      makeTag (n, s, sp) {
        return `Option ${n} - ${s} - ${sp}`
      },
      updateOption (data) {
        /*
        if (!this.providersCodeToName.hasOwnProperty(data.option.serviceProvider)) {
          let arr = []
          arr.push(data.option.serviceProvider)
          this.$store.dispatch('quote/addProviders', arr)
        }
        */
        this.$emit('choice-made', data)
      },
      getQuality (arr) {
        let count = 0
        let qualitySum = 0
        arr.forEach(({providerQuality}) => {
          if (providerQuality) {
            count++
            qualitySum += providerQuality
          }
        })
        return count ? parseInt(qualitySum / count) : count
      },
      getRate (n) {
        const rate = this.response.option.find(({optionNumber}) => optionNumber === n)
        return rate || null
      },
      getDuration (obj) {
        return obj.item.reduce((val, {duration, durationType}) => {
          return val + (durationType === 'D' ? duration : (duration / 24).toFixed(2))
        }, 0)
      },
      chosen (rateOptionNumber) {
        this.choiceMade = true
        this.choice = rateOptionNumber
        setTimeout(() => {
          VueScrollTo.scrollTo('#rate-breakdown-window', 250, {})
        }, 100)
      },
      itemChosen ({rateOptionNumber, itemIndex}) {
        this.itemChoiceMade = true
        this.itemChoice = rateOptionNumber
        this.itemChoiceIndex = itemIndex
        setTimeout(() => {
          VueScrollTo.scrollTo('#item-rate-breakdown-window', 250, {})
        }, 100)
      },
      showGraph (optNumber) {
        this.pathNumber = optNumber - 1
        this.graphVisible = true
      },
      getServiceWithNote (service) {
        return this.prefWithNotes.filter(pref => pref.serviceCode === service)
      },
      setServiceNotes () {
        if (this.response && this.prefWithNotes && this.prefWithNotes.length > 0 &&
          this.response.option && this.response.option.length > 0) {
          this.response.option.forEach(option => {
            option.item.forEach(item => {
              const service = this.getServiceWithNote(item.service)
              if (service && service.length > 0) {
                item.serviceNote = service[0].note
              }
            })
          })
        }
      }
    },
    mounted () {
      /*
      let providers = []
      this.response.option.forEach(option => {
        option.item.forEach(item => {
          if (!providers.includes(item.serviceProvider)) {
            providers.push(item.serviceProvider)
          }
        })
      })
      this.$store.dispatch('quote/getProviders', providers)
      */
      const baseCurrencyCode = this.response && this.response.responseCurrency
      this.$store.dispatch('quote/getFinanceItems', { financeProfileId: this.chargeProfile, baseCurrencyCode })
      this.setServiceNotes()
    }
  }
</script>

<style scoped>
  section#rates {
    position: relative;
  }
  #back-to-quote-request {
    position: absolute;
    top: 0;
    left: 0;
  }
  .inverse {
    background: #fff;
    padding: 10px;
    color: #949292;
    font-weight: bold;
  }
  .inverse .nb {
    font-weight: normal;
  }
  .sorter {
    margin: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .sorters {
    display: flex;
  }
  .sorters span {
    max-height: 30px;
    font-size: 15px;
    overflow: hidden;
    cursor: pointer;
    background: #444;
    color: #fff;
    padding: 3px 10px;
  }
  .sorters span:first-child {
    margin-right: 2px;
  }
  .sorters span  div {
    transition: transform 0.5s;
  }
  .sorters span div.open {
    transform: translateY(-21px);
  }
  .select-sort {
    margin: 20px;
  }
  .select-sort .msg {
    float: left;
    display: inline-block;
  }
  .select-sort select {
    border: none;
    float: right;
  }
  .details div {
    border: 1px solid;
    margin: 3px;
  }
  .details div span.key {
    padding: 10px;
    display: inline-block;
    width: 90px;
    border-right: 1px solid;
    text-align: center;
  }
  .details div span.nb {
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
  .tag {
    text-align: center;
    margin: 5px;
  }
  .tag .key-head {
    background-color: #0095da;
    color: #fff;
  }
  .tag .val {
    border: 1px solid #949292;
    min-height: 20px;
  }
  .mai-nav-pills {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/modules/quote/components/QuoteRates.vue